import { Column } from 'app/design/primitives/box';
import { BottomSheet } from 'app/design/primitives/bottom-sheet';
import { Text } from 'app/design/primitives/text';

import { useTranslation } from 'react-i18next';
import { createTheme as createDSTheme } from 'app/shopify';
import { IconBellOff } from '@tabler/icons-react-native';
import { ICON_STROKE_WIDTH } from 'app/utils/constants';
const theme = createDSTheme();

interface SilenceConversationBottomSheetProps {
  open: boolean;
  onClose: () => void;
  onSelectDuration: (durationMinutes?: number) => void;
}

const OPTIONS: { labelKey: string; durationMinutes?: number }[] = [
  { labelKey: 'silenceFor15Minutes', durationMinutes: 15 },
  { labelKey: 'silenceFor1Hour', durationMinutes: 60 },
  { labelKey: 'silenceFor8Hours', durationMinutes: 8 * 60 },
  { labelKey: 'silenceFor24Hours', durationMinutes: 24 * 60 },
  { labelKey: 'silenceFor48Hours', durationMinutes: 48 * 60 },
  { labelKey: 'silenceFor1Week', durationMinutes: 24 * 60 * 7 },
  { labelKey: 'silenceUntilChanged' },
];

export function SilenceConversationBottomSheet({
  open,
  onClose,
  onSelectDuration,
}: SilenceConversationBottomSheetProps) {
  const { t } = useTranslation('one-channel');

  return (
    <BottomSheet open={open} onClose={onClose}>
      <Column gap="spacing.general.x1" paddingBottom="spacing.general.x4" paddingHorizontal="spacing.general.x5">
        <Text textAlign="center" variant="bodyLarge">
          {t('silenceNotifications')}
        </Text>
        <Text color="text.secondary" textAlign="center" variant="bodyBase">
          {t('silenceDurationPrompt')}
        </Text>
      </Column>
      {OPTIONS.map((option) => (
        <BottomSheet.Action
          key={option.labelKey}
          onPress={() => {
            onClose();
            onSelectDuration(option.durationMinutes);
          }}
          prefix={<IconBellOff strokeWidth={ICON_STROKE_WIDTH} size={20} color={theme.colors['text.secondary']} />}
        >
          {t(option.labelKey)}
        </BottomSheet.Action>
      ))}
    </BottomSheet>
  );
}
